export function shouldIgnoreRichTextBlur(
  container: Node | null | undefined,
  relatedTarget: EventTarget | null | undefined
): boolean {
  return container?.contains(relatedTarget as Node | null) ?? false;
}
